import React from "react";
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import { Link } from "react-router-dom";   // ✅ correct routing
import './StorieSlider2.css'
import ViewMoreButtonDesktop, { ViewMoreButtonMobile } from "../WebButton/ViewMoreButton";

const StorieSlider2 = (props) => {
    const { list = [], title, url } = props;

    const responsive = {
        superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 4 },
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
        tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
        mobile: { breakpoint: { max: 464, min: 0 }, items: 2 }
    };

    return (
        <section className='storieslider2'>
            <Container className='card-section'>
                
                <Row>
                    <div className="whitetitle">
                        <h1>{title}</h1>
                        <ViewMoreButtonDesktop redirect={url} />
                    </div>
                </Row>

                <Carousel responsive={responsive} autoPlaySpeed={2000} autoPlay infinite>
                    {list.map((item, index) => {

                        const {
                            post_url,
                            search_url,
                            imagepath,
                            title
                        } = item;

                        // ✅ FINAL URL LOGIC
                       const finalUrl = `/search/${encodeURIComponent(search_url || title)}`;

                        return (
                            <Row key={index} className="slidecardrow p-2">
                                <Col lg={12}>

                                    {/* ✅ IMAGE LINK */}
                                    <Link to={finalUrl}>
                                        <img 
                                            src={imagepath} 
                                            alt={title} 
                                            loading="lazy" 
                                        />
                                    </Link>

                                    <Card.Body>
                                        {/* ✅ TITLE LINK */}
                                        <Link to={finalUrl} style={{ textDecoration: "none" }}>
                                            <Card.Title className='word-line-limit 3 text-center shadow-sm' style={{fontSize: '1rem'}} >
                                                {title}
                                            </Card.Title>
                                        </Link>
                                    </Card.Body>

                                </Col>
                            </Row>
                        );
                    })}
                </Carousel>

                <ViewMoreButtonMobile redirect={url} />
            </Container>
        </section>
    );
};

export default StorieSlider2;